import { render, staticRenderFns } from "./CenterViewEventDesignUpload_Ap.vue?vue&type=template&id=f5f1e480&scoped=true"
import script from "./CenterViewEventDesignUpload_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventDesignUpload_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventDesignUpload_Ap.vue?vue&type=style&index=0&id=f5f1e480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f1e480",
  null
  
)

export default component.exports